import { render } from "./AuthenticationHistory.vue?vue&type=template&id=7a622b3a&ts=true"
import script from "./AuthenticationHistory.vue?vue&type=script&lang=ts"
export * from "./AuthenticationHistory.vue?vue&type=script&lang=ts"

import "./AuthenticationHistory.vue?vue&type=style&index=0&id=7a622b3a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__